export default {
    english: {
      links: {
        privacy: {
          label: 'Privacy, Cookies, Security & Legal',
          url: 'https://www.wellsfargo.com/privacy-security/'
        },
        data: {
          label: 'Notice of Data Collection',
          url: 'https://www.wellsfargo.com/privacy-security/notice-of-data-collection/'
        },
        terms: {
          label: 'General Terms of Use',
          url: 'https://www.wellsfargo.com/privacy-security/terms/'
        },
        access: {
          label: 'Online Access Agreement',
          url: 'https://www.wellsfargo.com/online-banking/online-access-agreement/'
        },
        oneTrust: {
          label: 'Do Not Sell or Share My Personal Information',
          url: '#'
        },
        fraud: {
          label: 'Report Fraud',
          url: 'https://www.wellsfargo.com/privacy-security/fraud/report/'
        },
        about: {
          label: 'About Wells Fargo',
          url: 'https://www.wellsfargo.com/about/',
          alt: 'About Wells Fargo'
        },
        careers: {
          label: 'Careers',
          url: 'https://www.wellsfargo.com/about/careers/'
        },
        diversity: {
          label: 'Inclusion and Accessibility',
          url: 'https://www.wellsfargo.com/about/diversity/'
        },
        sitemap: {
          label: 'Sitemap',
          url: 'https://www.wellsfargo.com/sitemap'
        },
        home: {
          label: 'Home',
          url: 'https://www.wellsfargo.com/'
        },

      },
      fdic: 'Wells Fargo Bank, N.A. Member FDIC.'
    },
    spanish: {
      links: {
        privacy: {
          label: 'Privacidad, cookies, seguridad y asuntos legales',
          url: 'https://www.wellsfargo.com/es/privacy-security/'
        },
        data: {
          label: 'Aviso sobre recopilación de datos',
          url: 'https://www.wellsfargo.com/es/privacy-security/notice-of-data-collection/'
        },
        terms: {
          label: 'Términos generales de uso',
          url: 'https://www.wellsfargo.com/es/privacy-security/terms/'
        },
        access: {
          label: 'Contrato de Acceso por Internet',
          url: 'https://www.wellsfargo.com/es/online-banking/online-access-agreement/'
        },
        oneTrust: {
          label: 'No Vendan ni Compartan Mi Información Personal',
          url: '#'
        },
        fraud: {
          label: 'Reporte el fraude',
          url: 'https://www.wellsfargo.com/es/privacy-security/fraud/report/'
        },
        about: {
          label: <>Acerca de <span lang="en">Wells Fargo</span></>,
          url: 'https://www.wellsfargo.com/es/about/',
          alt: 'Acerca de Wells Fargo'
        },
        careers: {
          label: 'Empleos (en inglés)',
          url: 'https://www.wellsfargo.com/about/careers/'
        },
        diversity: {
          label: 'Inclusión y accesibilidad',
          url: 'https://www.wellsfargo.com/es/about/inclusion/'
        },
        sitemap: {
          label: 'Mapa del sitio',
          url: 'https://www.wellsfargo.com/es/sitemap/'
        },
        home: {
          label: 'Página principal',
          url: 'https://www.wellsfargo.com/es/'
        },

      },
      fdic: <><span lang="en">Wells Fargo Bank</span>, N.A. Miembro <span lang="en">FDIC</span>.</>
    },
}
